import translate from '@/lib/intl/translate';
import { createApiRequest } from '@/utils/services';
import { showErrorMessage, showSuccessMessage } from '@/utils/ToastFeedback';

export async function createTask(data) {
  try {
    const result = await createApiRequest({
      method: 'post',
      path: 'tasks',
      data,
      throwErrors: true,
    });

    showSuccessMessage({
      message: translate('TASKS_CREATE_SUCCESS'),
    });

    return result;
  } catch (e) {
    showErrorMessage({
      message: translate('TASKS_CREATE_ERROR'),
    });

    return e;
  }
}

export async function updateTask({ taskId, ...data }) {
  try {
    await createApiRequest({
      method: 'put',
      path: `tasks/${taskId}`,
      data,
      throwErrors: true,
    });
    showSuccessMessage({
      message: translate('TASKS_UPDATE_SUCCESS'),
    });
  } catch (e) {
    showErrorMessage({
      message: translate('TASKS_UPDATE_ERROR'),
    });
  }
}

export async function deleteTask(taskId, ownerOrgId) {
  try {
    await createApiRequest({
      method: 'delete',
      data: {
        ownerOrgId,
      },
      path: `tasks/${taskId}`,
      throwErrors: true,
    });
    showSuccessMessage({
      message: translate('TASKS_DELETE_SUCCESS'),
    });
  } catch (e) {
    showErrorMessage({
      message: translate('TASKS_DELETE_ERROR'),
    });
  }
}
